<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Árbol aprobación" key="1">
          <wf-approval-hierarchy></wf-approval-hierarchy>
        </a-tab-pane>
        <a-tab-pane tab="Administración de vacaciones" key="2">
          <g-master name="forms"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    @action="masterAction"
                    modalWidth="90%"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Persona')"
                            :formItemConfig="fiOptions"
                            endpoint="personas"
                            ref="person"
                            :decorator="['id_person', { rules: [{ required: false}] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Empleado')"
                            :formItemConfig="fiOptions"
                            endpoint="empleados"
                            :selectedObj.sync="empleado"
                            :decorator="['id_emp', { rules: [{ required: false }] }]"
                            ref="empleado"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Resolución')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['id_resolution']"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha resolución')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['resolution_date']"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha inicio')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['start_date', {  rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Cant. aprobada')" v-bind="fiOptions">
                    <a-input-number
                      v-decorator="['approved_ammount', { rules: [
                            { required: false},
                           ] }]"
                      style="width: 100%">
                    </a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Cant. disponible')" v-bind="fiOptions">
                    <a-input-number
                      v-decorator="['available_ammount', { rules: [
                            { required: false},
                           ] }]"
                      style="width: 100%">
                    </a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Cant requerida')" v-bind="fiOptions">
                    <a-input-number
                      v-decorator="['requested_ammount', { rules: [
                            { required: false},
                           ] }]"
                      style="width: 100%">
                    </a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha solicitada')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['requested_date', {  rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Año')" v-bind="fiOptions">
                    <a-select v-decorator="['year', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                      <a-select-option v-for="year_ in years" :key="year_">
                        {{ year_ }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                    <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                      <a-select-option v-for="month_ in months_name" :key="month_.value">
                        {{ month_.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Periodo')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :decorator="['payment_period']"
                              :params="period_request">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              endpoint="hierarchy_lookup"
                              :decorator="['status']"
                              :params="request_status"
                              :selectedObj.sync="status">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Número documento')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['document_number', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Comentarios')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Dir. contacto')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['contact_address', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Cant req dinero')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['amount_required_money', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Tel. de contacto')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['contact_telephone', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Celular')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['contact_movil', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Aprobador 1')"
                            :formItemConfig="fiOptions"
                            endpoint="personas"
                            ref="person1"
                            :decorator="['attribute1', { rules: [{ required: false}] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Aprobador 2')"
                            :formItemConfig="fiOptions"
                            endpoint="personas"
                            ref="person2"
                            :decorator="['attribute2', { rules: [{ required: false}] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup :label="$t('Aprobador 3')"
                            :formItemConfig="fiOptions"
                            endpoint="personas"
                            ref="person3"
                            :decorator="['attribute3', { rules: [{ required: false}] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Atributo 4', { rules: [{ required: false }] })" v-bind="fiOptions">
                    <a-input
                      v-decorator="['attribute4', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Atributo 5')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['attribute5', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Atributo 6')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['attribute6', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Atributo 7')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['attribute7', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Atributo 8')" v-bind="fiOptions">
                    <a-input
                      v-decorator="['attribute8', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha de pago')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['attribute9', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha sistema')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['attribute10', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>

              </a-row>
            </template>
          </g-master>
          <a-row>
            <a-tabs defaultActiveKey="1">
              <a-tab-pane tab="DETALLE" key="1">
                <g-descriptions-detail v-if="detalle" :detalle="detalle" :valoresExpandidos="master.valoresExpandidos"/>
                <span v-else>Seleccione para ver más.</span>
              </a-tab-pane>
            </a-tabs>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-row>

  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        status: {},
        empleado: {},
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        request_status: {h_lookup_type: 'WF_STATUS_VACATIONS', use_code: true},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'ID solicitud', column: 'wf_request_id'},
            {label: 'ID Resolución', column: 'id_resolution'},
            {label: 'Fecha de resolución', column: 'resolution_date_desc'},
            {label: 'Cant. aprobada', column: 'approved_ammount'},
            {label: 'Cant. disponible', column: 'available_ammount'},
            {label: 'Cant. requerida', column: 'requested_ammount'},
            {label: 'Fecha de inicio', column: 'fecha_inicio_vacacion'},
            {label: 'Fecha de fin', column: 'fecha_fin_vacacion'},
            {label: 'Comentario', column: 'comments'},
            {label: 'Dirección', column: 'contact_address'},
            {label: 'Celular', column: 'contact_movil'},
            {label: 'Teléfono', column: 'contact_telephone'},
            {label: 'Dir. contacto', column: 'contact_address'},
            {label: 'Número del Documento', column: 'document_number'},
            {label: 'Fecha solicitada', column: 'requested_date_desc'},
            {label: 'Cant requerida dinero', column: 'amount_required_money'},
            {label: this.$t('Atributo 1'), column: 'attribute1_desc'},
            {label: this.$t('Atributo 2'), column: 'attribute2_desc'},
            {label: this.$t('Atributo 3'), column: 'attribute3_desc'},
            {label: this.$t('Atributo 4'), column: 'attribute4'},
            {label: this.$t('Atributo 5'), column: 'attribute5'},
            {label: this.$t('Atributo 6'), column: 'attribute6'},
            {label: this.$t('Atributo 7'), column: 'attribute7'},
            {label: this.$t('Atributo 8'), column: 'attribute8'},
            {label: this.$t('Atributo 9'), column: 'fecha_pago'},
            {label: this.$t('Atributo 10'), column: 'attribute10_desc'}
          ],
          endpoint: 'wf_request',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              pagination: {
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              },
              rowKey: 'wf_request_id'
            },
            columns: [
              {title: 'Empleado', dataIndex: 'id_emp_desc', sorter: true},
              {title: 'Compañía', dataIndex: 'company_desc', sorter: true},
              {title: 'Tipo Solicitud', dataIndex: 'request_type', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month_desc', sorter: true},
              {title: 'Período pago', dataIndex: 'payment_period_desc', sorter: true},
              {title: 'Estado', dataIndex: 'status', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.status === 'LIQUIDADA'
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return record.status === 'LIQUIDADA'
                  }
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'id_person'},
            {name: 'id_emp'},
            {name: 'id_person'},
            {name: 'id_resolution'},
            {name: 'resolution_date', type: 'date'},
            {name: 'payment_period'},
            {name: 'start_date', type: 'date'},
            {name: 'end_date', type: 'date'},
            {name: 'approved_ammount'},
            {name: 'available_ammount'},
            {name: 'requested_date', type: 'date'},
            {name: 'requested_ammount'},
            {name: 'year'},
            {name: 'month'},
            {name: 'status'},
            {name: 'document_number'},
            {name: 'comments'},
            {name: 'contact_address'},
            {name: 'amount_required_money'},
            {name: 'contact_telephone'},
            {name: 'contact_movil'},
            {name: 'attribute1'},
            {name: 'attribute2'},
            {name: 'attribute3'},
            {name: 'attribute4'},
            {name: 'attribute5'},
            {name: 'attribute6'},
            {name: 'attribute7'},
            {name: 'attribute8'},
            {name: 'attribute9', type: 'date'},
            {name: 'attribute10', type: 'date'}
          ]
        }
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.id_person)) {
                this.$refs.person && this.$refs.person.handleSearch(action.record.id_person)
              }
              if (!JsUtils.isEmpty(action.record.attribute1)) {
                this.$refs.person1 && this.$refs.person1.handleSearch(action.record.attribute1)
              }
              if (!JsUtils.isEmpty(action.record.attribute2)) {
                this.$refs.person2 && this.$refs.person2.handleSearch(action.record.attribute2)
              }
              if (!JsUtils.isEmpty(action.record.attribute3)) {
                this.$refs.person3 && this.$refs.person3.handleSearch(action.record.attribute3)
              }
            })
            break
        }
      }
    },
    computed: {
      detalle () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/WfRequest/WfRequest.vue